import {PayrollCompensationItemType, PayrollDefaultsPushMode} from "../../../../__generated__/generated_types";

export function defaultsPushModeToLabel(defaultsPushMode: PayrollDefaultsPushMode | undefined | null): string {
    switch (defaultsPushMode) {
        case PayrollDefaultsPushMode.Set:
            return "Replace";
        case PayrollDefaultsPushMode.Merge:
            return "Merge";
        case PayrollDefaultsPushMode.Add:
            return "Add";
        default:
            return "Unknown";
    }
}

export function defaultsPushCompensationTypesToLabel(compensationType: PayrollCompensationItemType | "base" | "overtime" | "raise" | "bonus"): string {
    switch (compensationType) {
        case "base":
            return "Base Compensation";
        case "overtime":
            return "Overtime";
        case "raise":
            return "Raises";
        case "bonus":
            return "Bonuses";
        case PayrollCompensationItemType.Medical:
            return "Medical";
        case PayrollCompensationItemType.Dental:
            return "Dental";
        case PayrollCompensationItemType.Vision:
            return "Vision";
        case PayrollCompensationItemType.Retirement_401KMatch:
            return "401K";
        case PayrollCompensationItemType.MedicareTax:
            return "Medicare";
        case PayrollCompensationItemType.SocialSecurityTax:
            return "Social Security Tax";
        case PayrollCompensationItemType.FederalUnemploymentTax:
            return "Federal Unemployment Tax";
        case PayrollCompensationItemType.StateUnemploymentTax:
            return "State Unemployment Tax";
        case PayrollCompensationItemType.WorkersCompensation:
            return "Workers' Compensation";
        default:
            return "Unknown";
    }
}